$.fn.erplDropdown = function(){

    var dropdown = this;
    var dropdownBtn = $(dropdown).find('.erpl_dropdown-btn')
    var dropdownContent = $(dropdown).find('.erpl_dropdown-content')
    var isAutoClose = $(dropdown).attr('data-auto-close')
    var isAutoFocus = $(dropdown).attr('data-auto-focus')
    var contentWidth = $(dropdown).attr('data-content-width');
    var $dropdownMenu = $(dropdown).find('.erpl_dropdown-menu');

    if (!dropdown || !dropdownBtn || !dropdownContent) {
        return
    }

    $(dropdownContent).on('click', function (e) { e.stopPropagation() })

    if (isAutoClose === "true") {
        $('body').on('click', function () {
            if ($(dropdownBtn).attr('aria-expanded') === "true") {
                $(dropdownContent).collapse('hide')
            }
        })
    }

    if (isAutoFocus === "true") {
        $(dropdownContent).on('shown.bs.collapse', function () {
            $(dropdownContent).find(evostrap.focusable).first().trigger("focus");
        })
    }



    $(dropdownContent).on('show.bs.collapse', function () {

        // Si le contenu dépasse la largeur du bouton, déterminer le position optimale du contenu 'left' or 'right'
        if ($(dropdownContent).width() > $(dropdownBtn).width()) {
            // Vérifier si l'espace disponible est plus important à gauche ou à droite. 
            let offset = $(dropdownBtn).offset();
            let leftSpace = offset.left;
            let rightSpace = $(window).width() - $(dropdownBtn).width() - offset.left; 
            let maxWidth;

            if (leftSpace > rightSpace) {
                // Position à droite
                $(dropdownContent).css('left', 'auto');
                $(dropdownContent).css('right', '0');

                maxWidth = leftSpace + $(dropdownBtn).width();
            } else {

                // Position à droite
                $(dropdownContent).css('left', '0');
                $(dropdownContent).css('right', 'auto');

                maxWidth = rightSpace + $(dropdownBtn).width();
            }

            $(dropdownContent).css("max-width", maxWidth + "px");
        }
    })

    if (contentWidth && contentWidth != "auto" ) {
        $(dropdownContent).width(contentWidth)
    }


    let close = () => {
        $(dropdownContent).collapse('hide');

        
    }

    // WAI Menu
    if ($dropdownMenu.length) {


        let $menuItems = $dropdownMenu.find('.erpl_dropdown-menu-item');

        // Focus sur le premier élément de la liste lorsque l'utilisateur presse bas sur le bouton
        dropdownBtn.on("keydown", function(e) {
            if (e.keyCode === evostrap.key.down && $menuItems && $menuItems.length) {
                e.preventDefault();
                $menuItems[0].focus();
            } 
        })


        /* Ferme la liste déroulante lorsque l'utilisateur clique ou navigue en dehors de la liste déroulante. */
        dropdownBtn.on('focusout', function(e) {
            if (!dropdown[0].contains(e.relatedTarget)) {
                close()
            }
        })

        dropdown.on("keydown", function(e) {
            if (e.keyCode === evostrap.key.escape) {
                close();
                $(dropdownBtn).trigger("focus")
            }
        })

        // Gestion haut bas sur les éléments du menu
        $menuItems.each(function(index) {

            $(this).on("keydown", function(e) {
                // Navigation clavier sur éléments visibles
                let $menuItemsVisibles = $menuItems.filter(':visible');
                let currentVisibleIndex = $menuItemsVisibles.index($menuItems[index]);
                
                let prevEl = $menuItemsVisibles[currentVisibleIndex - 1];
                let nextEl = $menuItemsVisibles[currentVisibleIndex + 1];

                switch (e.keyCode) {
                    case evostrap.key.up:
                        e.preventDefault()

                        if (prevEl) {
                            $(prevEl).trigger("focus")
                        }

                        break;

                    case evostrap.key.down:
                        e.preventDefault()

                        if (nextEl) {
                            $(nextEl).trigger("focus")
                        }
                        break;

                    default:
                        break;
                }
            })

            /* Ferme la liste déroulante lorsque l'utilisateur clique ou navigue en dehors de la liste déroulante. */
            $(this).on('focusout', function(e) {
                if (!dropdown[0].contains(e.relatedTarget)) {
                    // FIX Safari - add timeout
                    setTimeout(() => {
                        close()
                    }, 100);
                }
            })
        })

    }

}

